<template>
  <div class="w-75 mb-3" :class="[message.side=='user'&&'ms-auto text-end']">
    <div class="card p-2">
      <div class="d-flex" style="max-width: 100%">
        <div class="col-1 text-center fs-4">
          <i class="bi" :class="{'user':'bi-person', 'robot':'bi-robot', 'operator':'bi-headset'}[message.side]"/>
        </div>
        <div class="d-flex flex-column" :class="{'text-light': isCommand}">
          {{ message.text }}
          <div v-if="message.html" v-html="message.html" style="max-width: 350px; overflow: hidden"></div>
        </div>
      </div>
    </div>
    <small>{{ format_datetime(new Date(message.timestamp * 1000)) }} {{ message.timestamp }}</small>
    <message-buttons v-if="json" :json="json"/>
  </div>
</template>

<script>
import {format_datetime} from "@/misc/util";
import MessageButtons from "@/components/widget/MessageButtons";

export default {
  components: {MessageButtons},

  props: ["message"],
  data() {
    return {
      json: null,
    }
  },
  mounted() {
    const body = this.message.html || this.message.text || "";

    const match = body.match(/\{\{(.*)}}/)

    const content = match ? "{" + match[1].trim() + "}" : null;

    try {
      this.json = JSON.parse(content)
    } catch (e) {
      console.error(e);
    }

  },
  methods: {
    format_datetime,
  },

  computed:{
    isCommand(){
      return (this.message.text || "").startsWith("\\");
    }
  }
}
</script>

